import { useIntl } from 'react-intl';

const renderDatePickerLocaleText = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intl = useIntl();

  return {
    previousMonth: intl.formatMessage({ id: 'datepicker.previousMonth', defaultMessage: 'Önceki Ay' }),
    nextMonth: intl.formatMessage({ id: 'datepicker.nextMonth', defaultMessage: 'Sonraki Ay' }),

    // for Mobile
    okButtonLabel: intl.formatMessage({ id: 'datepicker.okButtonLabel', defaultMessage: 'Tamam' }),
    cancelButtonLabel: intl.formatMessage({
      id: 'datepicker.cancelButtonLabel',
      defaultMessage: 'Vazgeç',
    }),
  };
};

export default renderDatePickerLocaleText;
